import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const CullingEditorDetail = () => {
  const [culling, setCulling] = useState({});
  const [status, setStatus] = useState(1);
  const [selectedEditor, setSelectedEditor] = useState("");
  const [fileLocation, setFileLocation] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  const getCullingById = async () => {
    try {
      const response = await axios.get(`/culling/${id}`);
      setCulling(response.data);
      setSelectedEditor(response.data.editor || "");
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1);
    } catch (error) {
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  useEffect(() => {
    getCullingById();
  }, []);

  const updateCulling = async () => {
    try {
      await axios.put(`/culling/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/culling-editor");
    } catch (error) {
      seterrorMessage("Failed to update order");
    }
  };

  return (
    <div className="container mt-4">
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="row">
        {/* Left Panel */}
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-header fw-600">Job Details</div>
            <div className="card-body">
              <p>
                <strong>Service Type:</strong> {culling?.serviceId?.service}
              </p>
            </div>
          </div>{" "}
          <div className="card mb-3">
            <div className="card-header fw-600">Order Detail</div>
            <div className="card-body">
              <p>
                <strong>Culling Percentage:</strong>{" "}
                {culling.culling_percentage}
              </p>{" "}
              <p>
                <strong>Keep my labels,flag and rating :</strong>{" "}
                {culling.labels_flag_rating}
              </p>{" "}
              <p>
                <strong>Output Format :</strong> {culling.output_format}
              </p>
              <p>
                <strong>Quantity :</strong> {culling.quantity}
              </p>{" "}
              <p>
                <strong>Aditional notes :</strong> {culling.additional_notes}
              </p>{" "}
              <p>
                <strong>Upload :</strong> {culling.images}
              </p>
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-header fw-600">Order Operations</div>
            <div className="card-body">
              <p>
                <strong>Client ID:</strong> {user.user.id}
              </p>
              <p>
                <strong>Order ID:</strong> {culling.id}
              </p>
              <p>
                <strong>User Feedback:</strong> {culling.sampleFeedback}
              </p>
              <p>
                <strong>Sample Status:</strong>{" "}
                {culling.sampleStatus === "approved" ? (
                  <span className="btn rounded-0 btn-success btn-sm p-2 ms-2">
                    Approved
                  </span>
                ) : culling.sampleStatus === "declined" ? (
                  <span className="btn rounded-0 btn-danger btn-sm p-2 ms-2">
                    Declined
                  </span>
                ) : (
                  <span className="text-muted ms-2">Not Selected</span>
                )}
              </p>
              <p>
                <strong>Order Place Date:</strong>{" "}
                {new Date(culling?.createdAt).toLocaleDateString()}
              </p>
              <div>
                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>{" "}
              </div>

              <div className="mt-3">
                <label className="form-label mt-3">Editor</label>
                <input
                  type="text"
                  className="form-control"
                  value={userName}
                  readOnly
                />
              </div>

              <label className="form-label mt-3">File Location</label>
              <input
                type="text"
                className="form-control"
                value={fileLocation}
                onChange={(e) => setFileLocation(e.target.value)}
              />

              <button
                onClick={updateCulling}
                className="btn text-light bg_maincolor mt-3"
              >
                Update 
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CullingEditorDetail;
